import React from 'react';
import { Tag } from 'rsuite';

import './iso-lang.scss';

export const IsoLang = ({ locale }) => <Tag className="lf-iso-lang" color="cyan">{locale}</Tag>;
